<template>
    <v-app>


<!--        <core-filter/>-->
<!--        <CoreFilter/>-->

        <!--        <core-toolbar/>-->
        <CoreToolbar v-if="state === States.SignedIn"/>

<!--        <core-drawer/>-->
<!--        <CoreDrawer v-if="state === States.SignedIn"/>-->
<!--        <CoreDrawer v-if="state === States.SignedIn"/>-->

<!--        <core-view/>-->
        <CoreView />

<!--        <CoreAuthPage />-->

    </v-app>
</template>

<style lang="scss">
    /*@import '@/styles/index.scss';*/
    @import "styles/index";

    /* Remove in 1.2 */
    .v-datatable thead th.column.sortable i {
        vertical-align: unset;
    }
</style>
<script>
  import CoreToolbar from './components/core/CoreToolbar';
  import CoreFilter from './components/core/CoreFilter';
  import CoreDrawer from './components/core/CoreDrawer';
  import CoreView from './components/core/CoreView';
  import tool_app from './utils/tool_app';
  import eventbus from './utils/eventbus';

  // let a = {
  //
  //   onAuth: async function (data) {
  //     tool_app.lg('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
  //     tool_app.lg('A new auth event has happened: 2 ', data.payload);
  //     await Auth.currentAuthenticatedUser()
  //       .then(() => {
  //         tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
  //         this.isSignedIn = true
  //       })
  //       .catch(() => {
  //         tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
  //         this.isSignedIn = false
  //       });
  //     // .then(() => this.isSignedIn = true)
  //     // .catch(() => this.isSignedIn = false);
  //   },
  // }

  // function lg (...args) {
  //   tool_app.lg('App] ', args);
  // }

  tool_app.isDebug = false;
  function lg (...args) { tool_app.lg('App] ', ...args); }

  export default {
    components: { CoreToolbar, CoreFilter, CoreDrawer, CoreView, },
    async beforeCreate() {
      tool_app.init();
      lg('beforeCreate 1:', window.location.href);
      if(window.location.href.indexOf('localhost') >= 0) {
        tool_app.isDebug = true;
      }
      eventbus.$on(eventbus.Events.Signed, (payload) => {
        lg('eventbus.Events.Signed 2 ', tool_app.isSignedIn());
        if(tool_app.isSignedIn()) {
          this.state = this.States.SignedIn;
          // if(this.$route.name === 'Sign'
          if(this.$router.currentRoute.path === '/sign') {
            // this.$router.replace({path: '/dashboard'});
            this.$router.replace({path: '/periodiccarmanage'});
          }
          else {
            // this.$router.replace({path: '/dashboard'});
          }
        }
        else {
          this.state = this.States.SignedOut;
          if(this.$router.currentRoute.path === '/sign') {
          }
          else {
            this.$router.replace({ path: '/sign' });
          }
        }

        // // this.$router.push('/');
        // lg('eventbus.Events.Signed 3 ', tool_app.isSignedIn());
        // // this.$router.replace({ path: '/home' });
        // // this.$router.replace({ path: '/' });
        // lg('eventbus.Events.Signed 4 ', tool_app.isSignedIn());

        // this.$route.replace('/')
          // this.isSignedIn = tool_app.isSignedIn();
          // this.$forceUpdate();
      });
      // Hub.listen('auth', (data) => {
      //   tool_app.lg('A new auth event has happened: a1 ', data.payload.data.username + ' has ' + data.payload.event);
      //
      //   this.$forceUpdate();
      //   tool_app.lg('A new auth event has happened: a2 ', this.isSignedIn);
      //   tool_app.lg('A new auth event has happened: a2 ', tool_app.isSignedIn());
      //
      //   // tool_app.lg('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
      //   // tool_app.lg('A new auth event has happened: 2 ', data.payload);
      //   // Auth.currentAuthenticatedUser()
      //   //   .then(() => {
      //   //     tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      //   //     this.isSignedIn = true
      //   //   })
      //   //   .catch(() => {
      //   //     tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      //   //     this.isSignedIn = false
      //   //   });
      //   // // .then(() => this.isSignedIn = true)
      //   // // .catch(() => this.isSignedIn = false);
      // });
      // // Hub.listen('auth', async function (data) {
      // //   tool_app.lg('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
      // //   tool_app.lg('A new auth event has happened: 2 ', data.payload);
      // //   await Auth.currentAuthenticatedUser()
      // //     .then(() => {
      // //       tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      // //       this.isSignedIn = true
      // //     })
      // //     .catch(() => {
      // //       tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      // //       this.isSignedIn = false
      // //     });
      // //   // .then(() => this.isSignedIn = true)
      // //   // .catch(() => this.isSignedIn = false);
      // // });
      tool_app.p.onAuth();
    },
    async beforeDestroy() {
      tool_app.destroy();
      // Hub.remove('auth', this.onAuth);
    },


    methods: {
      // onAuth: async function (data) {
      //   tool_app.lg('A new auth event has happened: 1 ', data.payload.data.username + ' has ' + data.payload.event);
      //   tool_app.lg('A new auth event has happened: 2 ', data.payload);
      //   await Auth.currentAuthenticatedUser()
      //     .then(() => {
      //       tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      //       this.isSignedIn = true
      //     })
      //     .catch(() => {
      //       tool_app.lg('onAuth 1 this.isSignedIn:', this.isSignedIn);
      //       this.isSignedIn = false
      //     });
      //   // .then(() => this.isSignedIn = true)
      //   // .catch(() => this.isSignedIn = false);
      // },
    },
    data: () => ({
      States: {
        Init: 'Init',
        SignedIn: 'SignedIn',
        SignedOut: 'SignedOut',
      },
      // isSignedIn: tool_app.isSignedIn(),
      state: null,
    }),
  }
</script>
